import { initializeApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import config from "./config";
// import { getAnalytics } from "firebase/analytics";

function initialize(existingApp) {
    const firebaseApp = existingApp || initializeApp(config);
    const auth = getAuth(firebaseApp);
    const firestore = getFirestore(firebaseApp);
    const storage = getStorage(firebaseApp);
    const db = getDatabase(firebaseApp);
    // const analytics = getAnalytics(app);
    return { firebaseApp, auth, firestore, storage, db };
}

export function getFirebase() {
    const existingApp = getApps().at(0);
    return initialize(existingApp);
}
